/* Office Colors — Hero slideshow (v2026-04-24f) */
(function(){
  const host = document.querySelector('.hero-slider');
  if(!host) return;
  const slides = host.querySelectorAll('.slide');
  if(slides.length < 2) return;
  const dots = host.querySelectorAll('.dot');
  const prev = host.querySelector('.arrow-prev');
  const next = host.querySelector('.arrow-next');
  const rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const INTERVAL = 3000;
  let cur = 0, timer = null;

  function setActive(i){
    slides.forEach((s, idx) => {
      const active = idx === i;
      s.classList.toggle('is-active', active);
      s.setAttribute('aria-hidden', active ? 'false' : 'true');
    });
    dots.forEach((d, idx) => {
      const active = idx === i;
      d.classList.toggle('is-active', active);
      d.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    cur = i;
  }
  function go(i){
    const n = slides.length;
    setActive(((i % n) + n) % n);
  }
  function start(){
    if(rm) return;
    stop();
    timer = setInterval(() => go(cur + 1), INTERVAL);
  }
  function stop(){
    if(timer){ clearInterval(timer); timer = null; }
  }

  if(next) next.addEventListener('click', () => { go(cur + 1); start(); });
  if(prev) prev.addEventListener('click', () => { go(cur - 1); start(); });
  dots.forEach((d, idx) => d.addEventListener('click', () => { go(idx); start(); }));

  host.addEventListener('mouseenter', stop);
  host.addEventListener('mouseleave', start);
  host.addEventListener('focusin', stop);
  host.addEventListener('focusout', start);

  document.addEventListener('keydown', e => {
    if(e.target.closest('input,textarea,select')) return;
    if(!host.matches(':hover') && !host.contains(document.activeElement)) return;
    if(e.key === 'ArrowRight'){ go(cur + 1); start(); }
    if(e.key === 'ArrowLeft'){ go(cur - 1); start(); }
  });

  start();
})();
